import './sendiks/style';
import FormStructure from './sendiks/form_structure';

export default FormStructure;